import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/PublicSans-Variable.woff2%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/PublicSans-Variable-Italic.woff2%22,%22style%22:%22italic%22}],%22display%22:%22swap%22,%22variable%22:%22--font-sans%22}],%22variableName%22:%22publicSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'publicSans', 'publicSans Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
